class EmoteListSingleton extends EventTarget
{
    constructor()
    {
        super();
        this.emotes = [];
        this.refresh();
    }
    
    _fireRefresh() { this.dispatchEvent(new Event("refresh")); }

    waitForRefresh()
    {
        return this._refreshPromise;
    }

    refresh()
    {
        if(this._refreshPromise)
            return this._refreshPromise;

        let promise = this._refreshPromise = this._refreshInner().then(() => {
            if(this._refreshPromise === promise)
                this._refreshPromise = null;
        });
        return this._refreshPromise;
    }

    async _refreshInner()
    {
        let resp = await fetch('/emote-list', { method: 'POST' });
        let data = await resp.json();
        let { emotes } = data;

        this.emotes.length = 0;
        for(let emoteInfo of emotes)
            this.emotes.push(emoteInfo);

        this._fireRefresh();
    }
}

export default new EmoteListSingleton();
